import type { KeywordFilter } from '@/modules/keywords/types';

export const KEYWORD_TOOL_AUTOCOMPLETE_REFERRER = 'keyword-tool-autocomplete';
export const KEYWORD_TOOL_DEFAULT_REFERRER = 'keyword-tool-default';

export const FILTER_OPTIONS: { label: string, value: KeywordFilter }[] = [
  {
    label: 'Match: Default',
    value: 'default_match',
  },
  {
    label: 'Match: Phrase',
    value: 'phrase_match',
  },
  {
    label: 'Match: Exact',
    value: 'exact_match',
  },
  {
    label: 'Match: Broad',
    value: 'broad_match',
  },
];

export const KEYWORD_IDEAS_TABLE_COLUMNS = {
  search_trend: {
    index: 0,
    visible: true,
  },
  average_searches: {
    index: 1,
    visible: true,
  },
  average_clicks: {
    index: 2,
    visible: true,
  },
  average_ctr: {
    index: 3,
    visible: true,
  },
  etsy_competition: {
    index: 4,
    visible: true,
  },
  keyword_difficulty: {
    index: 5,
    visible: true,
  },
  tag_occurrences: {
    index: 6,
    visible: true,
  },
  character_count: {
    index: 7,
    visible: true,
  },
  google_searches: {
    index: 8,
    visible: true,
  },
};

export const NEAR_MATCHES_TABLE_COLUMNS = {
  search_trend: {
    index: 0,
    visible: true,
  },
  average_searches: {
    index: 1,
    visible: true,
  },
  average_clicks: {
    index: 2,
    visible: true,
  },
  average_ctr: {
    index: 3,
    visible: true,
  },
  etsy_competition: {
    index: 4,
    visible: true,
  },
  keyword_difficulty: {
    index: 5,
    visible: true,
  },
  tag_occurrences: {
    index: 6,
    visible: true,
  },
  character_count: {
    index: 7,
    visible: true,
  },
  google_searches: {
    index: 8,
    visible: true,
  },
};

export const TOP_LISTINGS_TABLE_COLUMNS = {
  age: {
    index: 0,
    visible: true,
  },
  views: {
    index: 1,
    visible: true,
  },
  daily_views: {
    index: 2,
    visible: true,
  },
  est_sales: {
    index: 3,
    visible: true,
  },
  price: {
    index: 4,
    visible: true,
  },
  est_revenue: {
    index: 5,
    visible: true,
  },
  num_favorers: {
    index: 6,
    visible: true,
  },
};

export const POPULAR_MARKETPLACES_TABLE_COLUMNS = {
  search_trend: {
    index: 0,
    visible: true,
  },
  avg_searches: {
    index: 1,
    visible: true,
  },
  avg_clicks: {
    index: 2,
    visible: true,
  },
  avg_ctr: {
    index: 3,
    visible: true,
  },
};